export const OK_COLOR = 'green';
export const FAIL_COLOR = '#8b0000';
export const MODERATE_COLOR = '#FFD835';
export const POOR_COLOR = 'red';
export const WARNING_COLOR = '#FFD835';
export const NO_DATA_COLOR = 'grey';
export const NO_DATA_COLOR_2 = 'lightgrey';
// Scope map values
export const selectedPathOptions = {
    color: 'lime',
    weight: '1',
    opacity: '1',
    zIndex: '1',
    fillOpacity: '0.5',
};
export const unselectedPathOptions = {
    color: 'gray',
    weight: '1',
    opacity: '1',
    zIndex: '1',
    fillOpacity: '0.5',
};
export const initialDistrict = {
    color: '#FF695C',
    weight: '1',
    opacity: '1',
    zIndex: '1',
};
